module.exports = __webpack_public_path__ + "static/media/ylcard.48a37c42.png";